import { SIGN_IN, SIGN_OUT, SET_NAME, SET_EMAIL, SET_LOADING, SET_ROLE, SET_ADMIN, SET_APPROVER, SET_EDITOR, SET_BOOK_GROUP } from '../actions/types';

const INITIAL_STATE = {
    isAuthen: false,
    name: '',
    email: '',
    isLoading: false,
    role: {},
    isAdmin:false,
    isApprover:false,
    isEditor:false,
    bookGroup:[]
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SIGN_IN:
            return { ...state, isAuthen: true }
        case SIGN_OUT:
            return { ...state, isAuthen: false }
        case SET_NAME:
            return { ...state, name: action.payload }
        case SET_EMAIL:
            return { ...state, email: action.payload }
        case SET_LOADING:
            return { ...state, isLoading: action.payload }
        case SET_ROLE:
            return { ...state, role: action.payload }
        case SET_ADMIN:
            return { ...state, isAdmin: action.payload }
        case SET_APPROVER:
            return { ...state, isApprover: action.payload }
        case SET_EDITOR:
            return { ...state, isEditor: action.payload }    
        case SET_BOOK_GROUP:
            return { ...state, bookGroup: action.payload }    
        default:
            return state;
    }
}